export default __webpack_public_path__ + "assets/previlab-component.fef0f4c2.svg";